import { render } from "./Bxzj.vue?vue&type=template&id=7221f6a3&scoped=true"
import script from "./Bxzj.vue?vue&type=script&lang=js"
export * from "./Bxzj.vue?vue&type=script&lang=js"

import "./Bxzj.vue?vue&type=style&index=0&id=7221f6a3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7221f6a3"

export default script